import zIndex from '@mui/material/styles/zIndex';

const navSize = 14.688;
const navPadding = 1;

export const blogDetailsPageFullStyles = {
	position: 'relative',
	display: 'grid',
	justifyItems: 'flex-start',
	gridTemplateColumns: `${navSize}rem 1fr`,
	gap: { xs: '0', md: '1.5rem' },
	paddingX: { xs: '1rem', lg: '3.625rem' },
	paddingY: { xs: '.75rem ', md: '0' },
};

export const blogDetailsPageMainColumnStyles = {
	gridColumn: { xs: '1 / span 2', md: '2 / span 1' },
	maxWidth: { xs: '100%', lg: '50rem' },
};

export const blogDetailsPageSideNavColumnStyles = (
	isNavTopThreshold: boolean,
	isNavBottomLimit: boolean,
	offset?: number
) => ({
	position: 'relative',
	gridColumn: { xs: '1 / span 2', md: '1 / span 1' },
	width: { xs: '100%', md: `${navSize}rem` },
	marginTop: { xs: '0', md: `-${offset ?? 0}rem` },
	paddingBottom: { xs: isNavTopThreshold && !isNavBottomLimit ? '5rem' : '', md: 0 },
	minHeight: { xs: '4.464rem', md: '0' },
});

export const getNavPosition = (isNavTopThreshold: boolean, isNavBottomLimit: boolean, isSmallScreen: boolean) => {
	if (isNavTopThreshold && !isNavBottomLimit) return 'fixed';
	if (isNavBottomLimit || isSmallScreen) return 'absolute';
	return 'static';
};

export const blogDetailsPageSideNavStyles = ({
	isNavTopThreshold,
	isNavBottomLimit,
	offset = 0,
	parentContainerTop = 0,
	isSmallScreen = false,
}: {
	isNavTopThreshold: boolean;
	isNavBottomLimit: boolean;
	offset?: number;
	parentContainerTop?: number;
	isSmallScreen: boolean;
}) => ({
	position: getNavPosition(isNavTopThreshold, isNavBottomLimit, isSmallScreen),
	top: isNavTopThreshold && !isNavBottomLimit ? `calc(${offset}rem + ${parentContainerTop}px)` : '',
	bottom: isNavBottomLimit ? '0rem' : '',
	left: { xs: isNavTopThreshold ? '1rem' : '-1rem', md: 'auto' },
	width: { xs: isNavTopThreshold ? 'calc(100% - 2rem)' : 'calc(100% + 2rem)', md: `${navSize}rem` },
	zIndex: zIndex.fab,
	padding: `${navPadding}rem`,
	backgroundColor: 'backgrounds.light',
	borderRadius: '1rem',
	display: 'flex',
	flexFlow: 'column nowrap',
	alignItems: 'flex-start',
	justifyContent: 'flex-start',
});

export const blogDetailsPageFullTextStyles = {
	marginTop: '2rem',
	marginBottom: '5rem',
};

export const blogDetailsPageSideNavItemStyles = {
	flex: '1 1 auto',
	width: '100%',
	backgroundColor: { xs: 'backgrounds.light', md: 'backgrounds.light' },
	transition: 'backgroundColor 0.2s',
	padding: { xs: '0', md: '0' },
	'&:hover, &:active': {
		backgroundColor: { xs: 'backgrounds.neutral', md: 'backgrounds.neutral' },
	},
};

export const blogDetailsPageSideNavLinkStyles = {
	width: '100%',
	display: 'flex',
	padding: '0.5rem',
	flexFlow: 'row nowrap',
	justifyContent: 'space-between',
	alignItems: 'flex-start',
};

export const blogDetailsPageSideNavMobileMenuVisibleStyles = {
	width: '100%',
	padding: { xs: '0', md: '' },
	backgroundColor: 'backgrounds.light',
	zIndex: 2,
	borderRadius: '0 0 1rem 1rem',
	overflow: 'hidden',
};

export const blogDetailsPageInfoBarStyles = {
	width: '100%',
	flexFlow: { xs: 'column nowrap', md: 'row nowrap' },
	justifyContent: { sm: 'flex-start', md: 'space-between' },
	alignItems: { sm: 'flex-start', md: 'center' },

	marginTop: '1.5rem',
	paddingBottom: '2rem',
	borderBottom: '1px solid',
	borderColor: 'neutrals.primary',
	gap: '1rem',
};

export const blogDetailsCategoryPillStyle = {
	padding: '0.25rem 0.5rem',
	border: '1px solid',
	borderRadius: '0.5rem',
	borderColor: 'primary.light',
	display: 'inline-block',
};
